import r from "react";
import m from "@appchoose/cn";
const o = ({
  src: a,
  className: t,
  ...e
}) => /* @__PURE__ */ r.createElement("img", { src: a, className: m("size-8", t), alt: "", ...e });
o.displayName = "Avatar";
export {
  o as default
};
